import Link from "core-web/components/Link";
import React from "react";
import WallmekLogo from "theme/components/icons/WallmekLogo";
import { useTranslation } from "react-i18next";

const LogoLink = () => {
    // const dispatch = useAppDispatch();
    const { t } = useTranslation();

    return (
        <Link
            to="/"
            aria-label={t("header.aria_label.logo_link")}
            // onClick={() => dispatch(closeOverlay())}
        >
            <WallmekLogo height={["22px", null, "21px"]} />
        </Link>
    );
};

export default LogoLink;
